import React from 'react';

export const LogoutSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32}>
    <title>{'5CD9EB70-9143-4FF4-875E-36707BED3D29'}</title>
    <path
      fill="#333"
      fillRule="nonzero"
      d="M16 26a3 3 0 0 1-3-3v-1a1 1 0 0 1 2 0v1a1 1 0 0 0 1 1h7l.117-.007A1 1 0 0 0 24 23V9l-.007-.117A1 1 0 0 0 23 8h-7a1 1 0 0 0-1 1v1a1 1 0 0 1-2 0V9a3 3 0 0 1 3-3h7l.176.005A3 3 0 0 1 26 9v14l-.005.176A3 3 0 0 1 23 26h-7Zm-9.998-9.941v.011-.01L6 16.032v-.065a1.051 1.051 0 0 1 .049-.28.988.988 0 0 1 .021-.06l.023-.051.03-.061.022-.037a1.03 1.03 0 0 1 .05-.074l.024-.031-.007.01.03-.037.008-.01.042-.044 4-4 .094-.083a1 1 0 0 1 1.32.083l.083.094a1 1 0 0 1-.083 1.32L9.415 15H21l.117.007A1 1 0 0 1 21 17H9.415l2.292 2.293.083.094a1 1 0 0 1-1.497 1.32l-4-4-.073-.082a3.012 3.012 0 0 1-.024-.03 1.035 1.035 0 0 1-.102-.172l-.023-.052a.95.95 0 0 1-.06-.222l-.007-.064-.002-.026Z"
    />
  </svg>
);
